import validSlugPattern from './validSlugPattern';

/**
 * Check if the given string is a valid slug.
 * Valid Slug: "my-slug", "my-slug-123", "my-slug-123-456"
 * Invalid Slug: "my-slug-", "-my-slug", "my-slug--123", "my-slug-123-", "my-slug-123-", "invalid.slug"
 */
export function isSlug(input: string): boolean {
  return validSlugPattern.test(input);
}

export default isSlug;
